import { render, staticRenderFns } from "./detail-header.vue?vue&type=template&id=b69367fc&"
import script from "./detail-header.vue?vue&type=script&lang=js&"
export * from "./detail-header.vue?vue&type=script&lang=js&"
import style0 from "./detail-header.vue?vue&type=style&index=0&id=b69367fc&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports